export default class SearchComponent{

	constructor(){
    this.eventHandlers = this.eventHandlers.bind(this);
    this.toggle = this.toggle.bind(this);

		this.eventHandlers();
	}

	eventHandlers(){
		$('.search-toggle').on('click', this.toggle);
	}

	toggle(){
		var el = $('.search-form-container');
		var curEl = $('.search-toggle');

		if (el.hasClass('opened')){
			el.removeClass('opened');
			curEl.removeClass('opened');
		}else{
			el.addClass('opened');
			curEl.addClass('opened');
		}
	}
}



// WEBPACK FOOTER //
// ./scripts/components/search.js